import Vue from 'vue'
import SvgIcon from 'vue-svgicon'
// import all the icons
import '@/assets/icons'

import Button from '@/components/core/VButton'
import DefinitionList from '@/components/core/DefinitionList'

Vue.use(SvgIcon)

// Register global components
Vue.component('core-button', Button)
Vue.component('core-definition-list', DefinitionList)
